module.exports = new __parcel__URL__("proyectil.4865e68d.png").toString();